import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minuteSecond',
})
export class MinuteSecondPipe implements PipeTransform {
  public transform(value: string | number): string {
    const numericValue = typeof value === 'string' ? +value : value;

    if (isNaN(numericValue) || numericValue === 0) {
      return '0:00';
    }

    const minutes = Math.floor(numericValue / 60);
    const seconds = numericValue - minutes * 60;

    return `${minutes.toString().padStart(2, '0')}:${seconds.toFixed(0).padStart(2, '0')}`;
  }
}
